
define('app/home/unknown/unknownHomeApp',[
	'jquery',
	'underscore',
	'backbone',
	
	//Shims
	'jquery.cslider',
	'jquery.fancybox'
], function(
		$, 
		_, 
		Backbone){
	var initialize = function(){
		
		$('a.lightbox').fancybox({
			type        : 'image',
			openEffect  : 'fade',
			closeEffect	: 'fade',
			nextEffect  : 'fade',
			prevEffect  : 'fade',
			helpers     : {
				title   : {
					type : 'inside'
				}
			}
		});
	};
	
	return {
		initialize: initialize
	};
});